import classNames from "classnames";
import { OptionType } from "../../SelectInput";
import { MultiSelectOptionsProps } from "./MultiSelectOptions";

type MultiSelectElementProps = Pick<
  MultiSelectOptionsProps,
  "onSelectOption"
> & {
  option: OptionType;
  isSelected?: boolean;
};

export const MultiSelectElement = (props: MultiSelectElementProps) => {
  const { option, isSelected = false, onSelectOption } = props;
  const optionClass = classNames(
    "cursor-pointer px-2 py-1 hover:bg-slate-100",
    {
      "bg-slate-200": isSelected,
    },
  );
  const handleSelectOption = (value: string) => {
    onSelectOption?.(value);
  };
  return (
    <div
      key={option.value ?? option.label}
      aria-selected={isSelected}
      role="option"
      className={optionClass}
      onClick={() => {
        handleSelectOption?.(option.value.toString());
      }}
    >
      {option.label}
    </div>
  );
};
